// @ts-nocheck
import React from "react";

const ListTreeViewIcon: React.FC = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        fillRule="evenodd"
        clipRule="evenodd"
        style={{
            shapeRendering: "geometricPrecision",
            textRendering: "geometricPrecision",
            // @ts-ignore
            imageRendering: "optimizeQuality",
        }}
        viewBox="0 0 333.33 416.662"
    >
        <path
            d="M174.43 129.37h-29.64c-7.73 0-14.91-2.45-20.79-6.61v58.33c0 5.72 2.33 10.91 6.1 14.68 3.77 3.77 8.96 6.1 14.69 6.1h29.64v-17.3c0-4.23 3.43-7.66 7.65-7.66h69.78c4.22 0 7.65 3.43 7.65 7.66v49.92a7.65 7.65 0 0 1-7.65 7.65h-69.78a7.65 7.65 0 0 1-7.65-7.65v-17.3h-29.64c-7.73 0-14.91-2.45-20.79-6.61v58.33c0 5.72 2.33 10.92 6.1 14.69 3.77 3.76 8.96 6.1 14.69 6.1h29.64v-17.31a7.65 7.65 0 0 1 7.65-7.65h69.78c4.22 0 7.65 3.43 7.65 7.65v49.92a7.65 7.65 0 0 1-7.65 7.65h-69.78a7.65 7.65 0 0 1-7.65-7.65V305h-29.64c-9.94 0-18.97-4.05-25.51-10.59-6.54-6.54-10.59-15.56-10.59-25.51V68.6H81.45c-4.22 0-7.65-3.43-7.65-7.65V11.03a7.65 7.65 0 0 1 7.65-7.65h69.78c4.23 0 7.66 3.43 7.66 7.65v49.92c0 4.23-3.43 7.65-7.66 7.65h-27.24v24.67c0 5.72 2.34 10.92 6.1 14.69 3.77 3.76 8.96 6.1 14.69 6.1h29.64V96.75a7.65 7.65 0 0 1 7.65-7.65h69.78c4.22 0 7.65 3.43 7.65 7.65v49.92c0 4.22-3.43 7.65-7.65 7.65h-69.78a7.65 7.65 0 0 1-7.65-7.65v-17.31zm69.78-24.96h-54.47v34.61h54.47v-34.61zm0 87.82h-54.47v34.61h54.47v-34.61zm0 87.81h-54.47v34.62h54.47v-34.61zM143.59 18.68H89.12v34.61h54.48V18.68z"
            style={{
                fill: "currentColor",
                fillRule: "nonzero",
            }}
        />
    </svg>
);

export default React.memo(ListTreeViewIcon);
